if (!customElements.get('newsletter-modal')) {
  customElements.define('newsletter-modal', class NewsletterModal extends ModalElement {
    connectedCallback() {
      super.connectedCallback();
      if (Shopify.designMode || window.location.pathname === '/challenge') return;
      if (this.initialized || !theme.cookiesEnabled()) return;
      this.initialized = true;
      this.eligibleAt = Date.now() + this.delay * 1000;
      this.on(window, 'scroll', this.considerOpening.bind(this), { passive: true });
      this.on(document, 'visitorConsentCollected', this.considerOpening.bind(this));
      this.on(document, 'modal:afterHide', this.considerOpening.bind(this));
      this.on(document, 'drawer:afterHide', this.considerOpening.bind(this));
      this.timer = setTimeout(() => this.considerOpening(), this.delay * 1000);
      this.registerCleanup(() => clearTimeout(this.timer));
      if (this.submited) this.show();
    }
    get shouldLock() { return true; }
    get testMode() { return this.getAttribute('data-test-mode') === 'true'; }
    get delay() { return Math.max(0, parseInt(this.getAttribute('data-delay')) || 20); }
    get expiry() { return parseInt(this.getAttribute('data-expiry')) || 30; }
    get cookieName() { return 'concept:newsletter-popup'; }
    get submited() { return this.querySelector('.alert') !== null; }
    canAutoOpen() {
      if (this.open || this.autoOpened || document.hidden || Date.now() < this.eligibleAt) return false;
      const mode = this.getAttribute('data-auto-open') || 'desktop';
      if (mode === 'never' || (mode === 'desktop' && window.matchMedia('(max-width: 767px)').matches)) return false;
      if (!this.testMode && this.getCookie(this.cookieName)) return false;
      if (!this.testMode && window.scrollY < window.innerHeight * 0.4) return false;
      if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return false;
      if (document.querySelector('.drawer[open], .x-modal[open], [role="dialog"][aria-modal="true"]:not([hidden])')) return false;
      const privacy = window.Shopify?.customerPrivacy;
      try {
        if (typeof privacy?.shouldShowBanner === 'function') {
          if (privacy.shouldShowBanner()) return false;
        } else if (document.querySelector('pandectes-cmp')) {
          return false;
        }
      } catch (error) { return false; }
      return true;
    }
    considerOpening() {
      if (!this.isConnected || !this.canAutoOpen()) return;
      this.autoOpened = true;
      this.show();
    }
    beforeShow() { super.beforeShow(); clearTimeout(this.timer); }
    afterShow() { super.afterShow(); this.classList.add('show-image'); }
    afterHide() {
      super.afterHide();
      this.classList.remove('show-image');
      this.autoOpened = true;
      this.testMode ? this.removeCookie(this.cookieName) : this.setCookie(this.cookieName, this.expiry);
    }
    getCookie(name) {
      const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
      return match ? match[2] : null;
    }
    setCookie(name, expiry) {
      document.cookie = `${name}=true; max-age=${expiry * 86400}; path=/; SameSite=Lax; Secure`;
    }
    removeCookie(name) {
      document.cookie = `${name}=; max-age=0; path=/; SameSite=Lax; Secure`;
    }
  });
}
